export const fallbackCourseImage =
  'https://img-c.udemycdn.com/course/240x135/4427730_5388.jpg';
